import { useEffect, useState } from "react";
import api from "./api";

// Cache partagé : une seule requête /content pour tout le site
let cache = null;
let promise = null;

export function fetchSiteContent() {
  if (!promise) {
    promise = api
      .get("/content")
      .then(({ data }) => {
        cache = data && typeof data === "object" ? data : {};
        return cache;
      })
      .catch(() => {
        cache = {};
        return cache;
      });
  }
  return promise;
}

// Hook : retourne une fonction c(cle, valeurParDefaut)
// Si l'équipe a personnalisé le texte dans l'admin (Contenus), il est utilisé, sinon le défaut du code.
export function useSiteContent() {
  const [content, setContent] = useState(cache || {});
  useEffect(() => {
    fetchSiteContent().then(setContent);
  }, []);
  return (key, fallback = "") => {
    const v = content[key];
    return typeof v === "string" && v.trim() !== "" ? v : fallback;
  };
}
